<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
    style="max-width: 80%;"
  >
    <base-v-component
      heading="Simple Tables"
      link="components/simple-tables"
    />


    <!-- <div class="py-3" /> -->

    <base-material-card
      color="success"
      icon="mdi-clipboard-plus"
      title="Table on Dark Background"
      class="px-5 py-3"
    >
      <v-simple-table  dark>
        <thead>
          <tr>
            <th>X</th>
            <th>Full Name</th>
            <th>Phone Number</th>
            <th class="text-right">
             Order Date/Time
            </th>
          </tr>
        </thead>

        <tbody >
          <tr v-for="docs in this.orderArray" :key="docs.id">
            <td><font-awesome-icon id="xicon" @click.prevent="deleteDoc(docs.id)" icon="fa-solid fa-square-xmark" /></td>
            <td>{{docs.fullname}}</td>
            <td>{{docs.phonenumber}}</td>
            <td class="text-right">
              {{docs.ordertime}}
            </td>
          </tr>

          
        </tbody>
      </v-simple-table>
    </base-material-card>
  </v-container>
</template>
<script>
import firebase from 'firebase';

    export default {
        data () {

        return{
            orderArray: null,
            
        }},
        methods:{
                  
        submitOrder: function(){
         //this.showloading = true;
            console.log(this.user)
     
            },
             deleteDoc: function(d){
            if (confirm("Document Will Be Deleted") == true) {
            console.log(d);
            firebase.firestore().collection("RentalOrders").doc(d).delete().then(() => {
                
                    this.getDocs();
            })
              
            }
        },
            getDocs: function(){
                  firebase.firestore().collection("RentalOrders").get().then(snap => {
      let orders = [];
      snap.forEach(doc => {
        orders.push({id: doc.id,username: doc.data().username,fullname: doc.data().fullname,phonenumber:doc.data().phonenumber,ordertime: doc.data().ordertime})
        this.orderArray = orders;
        console.log("1")
            
            })
          })  
            this.$store.dispatch('updateDocs', this.orderArray);
          
            }
        },
         computed:{
          user(){
            return this.$store.state.user.username;
          },
           changeDocs: function(){
          return this.$store.state.docs
          }
        },
      
      mounted(){
         
        this.getDocs();
        }
    }
</script>
<style scoped>

#xicon:hover{
  cursor: pointer;
}

</style>
